import { usePlanStockTerm as useStockTerm } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-term/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanStockTerm = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { stockTypeTarget, stockTypeTerm, maxStockNum } = viewModel;

	return useStockTerm({
		stockTypeTerm,
		stockTypeTarget,
		maxStockNum,
		onSetViewModel,
	});
};
